import React, { useState, useEffect } from 'react';
import { getDayOptions, getMonthOptions, getYearOptionsRange } from '../../../constants/formOptions';

export const SegmentedDatePicker = ({ id, label, required, icon, value, onChange, error }) => {
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  // Sync internal state with incoming value (YYYY-MM-DD)
  useEffect(() => {
    if (value) {
      const parts = value.split('-');
      if (parts.length === 3) {
        setYear(parts[0] || '');
        setMonth(parts[1] || '');
        setDay(parts[2] || '');
      }
    }
  }, [value]);

  const handleDateChange = (newDay, newMonth, newYear) => {
    if (newDay && newMonth && newYear) {
      onChange({ target: { value: `${newYear}-${newMonth}-${newDay}` } });
    } else {
      onChange({ target: { value: '' } });
    }
  };

  const currentYear = new Date().getFullYear();
  const years = getYearOptionsRange(currentYear - 100, currentYear - 16); // DOB range
  const months = getMonthOptions();
  const days = getDayOptions();

  const selectClasses = "block w-full py-2 px-3 border border-gray-300 dark:border-gray-700 bg-white dark:bg-slate-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-usiu-blue-500/20 text-sm dark:text-white transition-all";

  return (
    <div className="space-y-1.5">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative group">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10">
            {icon}
          </div>
        )}
        <div className={`grid grid-cols-3 gap-2 ${icon ? 'pl-10' : ''}`}>
          <select
            value={day}
            onChange={(e) => { 
                setDay(e.target.value); 
                handleDateChange(e.target.value, month, year); 
            }}
            className={selectClasses}
          >
            <option value="">Day</option>
            {days.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
          </select>

          <select
            value={month}
            onChange={(e) => { 
                setMonth(e.target.value); 
                handleDateChange(day, e.target.value, year); 
            }}
            className={selectClasses}
          >
            <option value="">Month</option>
            {months.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>

          <select
            value={year}
            onChange={(e) => { 
                setYear(e.target.value); 
                handleDateChange(day, month, e.target.value); 
            }}
            className={selectClasses}
          >
            <option value="">Year</option>
            {years.map(y => <option key={y.value} value={y.value}>{y.label}</option>)}
          </select>
        </div>
      </div>
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};
